export default class AsyncCache<T> {
  private result: Promise<T> | null = null;

  constructor(private request: () => Promise<T>) {}

  public fetch(): Promise<T> {
    if (this.result == null) {
      this.result = this.request();
    }
    return this.result;
  }

  public reset(): void {
    this.result = null;
  }
}
